<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="modal_id" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-total" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{
                                documento
                                    ? documento.st_titulo
                                    : "Novo Documento"
                            }}

                            <span v-if="marcacao && marcacao.nome_paciente" class="ml-2 text-muted small">
                                para {{ marcacao.nome_paciente }}

                                <span v-if="marcacao.id_atendimento" class="ml-2">
                                    #{{ marcacao.id_atendimento }}
                                </span>
                            </span>
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="documento">
                            <div class="row">
                                <div class="col col-12" :class="anamnese && anamnese.dados ? 'col-md-8' : ''">
                                    <div class="input-group input-group-sm mb-3" v-if="( !recepcao || ( documento.modelo_documento && documento.modelo_documento.fl_salvar_recepcao ) ) && documento.fl_exibir_data !== null">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">
                                                <input class="fa-fw" type="checkbox" v-model="documento.fl_exibir_data" />
                                            </div>
                                        </div>
                                        <input type="date" class="form-control" placeholder="Nome do Kit..." v-if="documento.fl_exibir_data" v-model="documento.dt_referencia" />
                                        <label class="form-control" v-else>Sem data</label>
                                    </div>

                                    <template v-if="documento.carregando">
                                        <az-loading />
                                    </template>

                                    <template v-else>

                                        <div v-if="documento.fl_formulario">
                                            <formulario
                                                :validate="validate"
                                                :block_modelos="false"
                                                mode="fixed"
                                                v-model="documento.estrutura"
                                                :compact="documento.fl_compact"
                                                :infopaciente="infopaciente"
                                                :id_atendimento="( !recepcao && atendimento ) ? atendimento.id_atendimento : null"
                                                :id_procedimento="id_procedimento"
                                            />
                                        </div>
                                        <div v-else>
                                            <div class="mb-3">
                                                <div class="form-row">
                                                    <div class="col col-12 col-md-9">
                                                        <az-input
                                                            v-if="recepcao && !marcacao"
                                                            label="Para"
                                                            required
                                                            :validate="validate"
                                                            v-model="documento.st_nome_para"
                                                        />
                                                    </div>
                                                    <div class="col col-12 col-md-3">
                                                        <az-input
                                                            type="date"
                                                            v-if="recepcao && !marcacao"
                                                            label="Data"
                                                            :edicao="documento.fl_exibir_data"
                                                            :validate="validate"
                                                            v-model="documento.dt_referencia">
                                                            <template v-slot:button-pre>
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">
                                                                        <input class="fa-fw" type="checkbox"
                                                                            v-model="documento.fl_exibir_data"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>
                                                </div>

                                                <az-input
                                                    label="Título"
                                                    required
                                                    :edicao="!block_doc_titulo"
                                                    :validate="validate"
                                                    v-model="documento.st_titulo"
                                                />

                                                <div class="form-row" v-if="!recepcao && !documento.id_modelo_documento && !documento.id_modelo_prontuario">
                                                    <div class="col col-12 col-md-6">
                                                        <az-input
                                                            sizing="sm"
                                                            type="checkbox-group"
                                                            label="Não imprimir título"
                                                            :validate="validate"
                                                            v-model="
                                                                documento.fl_imprimir_sem_titulo
                                                            "
                                                        />
                                                    </div>
                                                    <div
                                                        class="col col-12 col-md-6"
                                                    >
                                                        <az-input
                                                            sizing="sm"
                                                            type="checkbox-group"
                                                            label="Texto Rico"
                                                            :validate="validate"
                                                            v-model="
                                                                documento.fl_html
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <template v-if="documento.fl_html">
                                                <div class="mt-3">
                                                    <az-editor
                                                        ref="htmleditor"
                                                        :readonly="!!( documento.modelo_documento && documento.modelo_documento.fl_block_edit )"
                                                        v-model="documento.st_descricao"
                                                        editorStyle="height: 320px"
                                                    />
                                                </div>
                                            </template>

                                            <template v-else>
                                                <az-input
                                                    type="textarea"
                                                    rows="10"
                                                    label="Conteúdo"
                                                    :edicao="!documento.modelo_documento || !documento.modelo_documento.fl_block_edit"
                                                    :required="!documento.modelo_documento || !documento.modelo_documento.fl_layout_word"
                                                    :validate="validate"
                                                    v-model="documento.st_descricao"
                                                />
                                            </template>

                                            <ul class="list-group mt-3" v-if="documento.arquivos && documento.arquivos.length">
                                                <li
                                                    class="list-group-item d-flex justify-content-between"
                                                    v-for="(arq,
                                                    iax) in documento.arquivos"
                                                    :key="iax"
                                                >
                                                    <a
                                                        :href="
                                                            arq.arquivo
                                                                .temporary_url
                                                        "
                                                        class="card-link"
                                                        target="_blank"
                                                    >
                                                        <i
                                                            class="fa fa-paperclip mr-2"
                                                            aria-hidden="true"
                                                        ></i>
                                                        {{ arq.arquivo.st_titulo }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </template>

                                    <template v-if="!documento.id_documento_atendimento && !documento.fl_formulario && !recepcao && !block_doc_titulo">
                                        <div class="custom-control custom-switch mt-3">
                                            <input type="checkbox" class="custom-control-input" id="salvarModeloSwitch" v-model="documento.salvar_modelo" />
                                            <label class="custom-control-label" for="salvarModeloSwitch">Salvar como Modelo</label>
                                        </div>
                                    </template>
                                </div>
                                <div class="col col-12 col-md-4" v-if="anamnese && anamnese.dados">
                                    <!-- height: 65vh; -->
                                    <div class="card overflow-auto" style="padding: 0px; height: 75vh;">
                                        <div class="card-header">
                                            Notas
                                        </div>
                                        <div class="card-body p-2">
                                            <formulario
                                                :onecol="true"
                                                v-model="anamnese.dados"
                                                mode="view"
                                                :view_with_print="false"
                                                tamanho="P"
                                                v-if="anamnese"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Lista para Seleção -->
                        <div v-else-if="modelos">
                            <div
                                v-if="tags && tags.length"
                                class="d-flex justify-content-end"
                            >
                                <a
                                    href="#"
                                    @click.prevent="selecionar_tag(tag)"
                                    v-for="(tag, itx) in tags"
                                    :key="itx"
                                >
                                    <span
                                        class="badge ml-1"
                                        :class="
                                            tag == search
                                                ? 'badge-success'
                                                : 'badge-secondary'
                                        "
                                    >
                                        {{ tag }}
                                    </span>
                                </a>
                            </div>

                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a
                                        class="nav-link active"
                                        id="home-tab"
                                        data-toggle="tab"
                                        href="#home"
                                        role="tab"
                                        aria-controls="home"
                                        aria-selected="true"
                                    >
                                        Modelos
                                        <span class="badge badge-secondary">
                                            {{ lista.length }}
                                        </span>
                                    </a>
                                </li>
                                <li class="nav-item" role="presentation" v-if="this.anamnese && this.historico && this.historico.length">
                                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
                                        Histórico
                                        <span class="badge badge-secondary">
                                            {{ lista_historico.length }}
                                        </span>
                                    </a>
                                </li>
                                <li class="nav-item" role="presentation" v-if="lista_documento_recepcao && lista_documento_recepcao.length">
                                    <a class="nav-link" id="doc-rec-tab" data-toggle="tab" href="#doc-rec" role="tab" aria-controls="doc-rec" aria-selected="false">
                                        Emitidos
                                        <span class="badge badge-secondary">
                                            {{ lista_recepcao.length }}
                                        </span>
                                    </a>
                                </li>
                            </ul>
                            <div class="tab-content" id="myTabContent">
                                <!--Modelos -->
                                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <div class="my-3">
                                        <az-input
                                            icon="fa fa-search"
                                            sizing="sm"
                                            placeholder="Pesquisar..."
                                            v-model="search_texto">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <button class="btn" :class="apenas_favoritos ? 'btn-outline-warning' : 'btn-outline-secondary'" type="button" id="button-addon2" @click="apenas_favoritos = !apenas_favoritos" title="Favoritos">
                                                        <i class="fa-solid fa-star fa-fw"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="list-group">
                                        <div>
                                            <!--class="d-flex justify-content-between mb-1"-->
                                            <div class="text-muted">
                                                Selecione o Documento:
                                            </div>
                                        </div>

                                        <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(modelo, im) in lista" :key="im">
                                            <div>
                                                <span>
                                                    <a href="#" @click.prevent title="Favoritar" @click="favoritar(modelo)" class="mr-3">
                                                        <i class="fa-regular fa-star fa-fw text-muted" v-if="!modelo.favorito"></i>
                                                        <i class="fa-solid fa-star fa-fw text-warning" v-else></i>
                                                    </a>

                                                    <a href="#" class="card-link" @click.prevent="selecionarDocumento(modelo)">
                                                        <i class="far fa-file-alt mr-2"></i>
                                                        {{ modelo.st_nome }}
                                                    </a>

                                                    <i class="fa fa-user-md ml-2" aria-hidden="true" v-if="modelo.id_medico"></i>
                                                </span>
                                                <span class="ml-2" v-if="modelo.js_classes">
                                                    <span class="badge badge-success ml-1" v-for="(tag, itx) in modelo.js_classes" :key="itx">
                                                        {{ tag }}
                                                    </span>
                                                </span>
                                            </div>
                                            <div>
                                                <a
                                                    :href="
                                                        arq.arquivo
                                                            .temporary_url
                                                    "
                                                    class="text-white"
                                                    v-for="(arq,
                                                    iax) in modelo.arquivos"
                                                    :key="iax"
                                                    target="_blank"
                                                >
                                                    <span
                                                        class="badge badge-primary p-2 ml-2"
                                                    >
                                                        <i
                                                            class="fa fa-paperclip mr-2"
                                                            aria-hidden="true"
                                                        ></i>
                                                        {{
                                                            arq.arquivo
                                                                .st_titulo
                                                        }}
                                                    </span>
                                                </a>

                                                <a href="#" @click.prevent="imprimir_doc(modelo)" class="card-link ml-4" v-if="recepcao">
                                                    <i class="fa fa-print fa-fw" aria-hidden="true"></i>
                                                </a>

                                                <a href="#" title="Enviar por e-mail" class="card-link ml-4" @click.prevent="enviar_documento_por_email(modelo)" v-if="recepcao">
                                                    <i class="far fa-envelope-open fa-fw"></i>
                                                </a>
                                            </div>
                                        </li>
                                        <button
                                            type="button"
                                            class="list-group-item list-group-item-action"
                                            @click="selecionarDocumento()"
                                        >
                                            <i class="fas fa-plus mr-2"></i>
                                            Novo
                                        </button>
                                    </div>
                                </div>

                                <!-- Documentos Emitidos da Recepção -->
                                <div class="tab-pane fade" id="doc-rec" role="tabpanel" aria-labelledby="doc-rec-tab">

                                    <az-input 
                                        v-if="model_type && model_id"
                                        sizing="sm"
                                        class="my-3"
                                        type="checkbox-group"
                                        label="Exibir documentos emitidos apenas nesse lançamento"
                                        v-model="filtro_by_model_id" />

                                    <ul class="list-group mt-3">
                                        <li class="list-group-item d-flex justify-content-between" v-for="(doc, idx) in lista_recepcao" :key="idx">
                                            <div>
                                                <a href="#" @click.prevent="selecionarDocumentoRecepcao(doc)">
                                                    {{ $util.getFormatDate(doc.dt_referencia ? doc.dt_referencia : doc.created_at.substr(0, 10)) }}
                                                    <span class="badge badge-warning ml-2" v-if="doc.fl_exibir_data === false">Sem data</span>
                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                    {{ doc.st_titulo }}
                                                    <span v-if="doc.modelo_documento && doc.modelo_documento.st_nome && doc.modelo_documento.st_nome != doc.st_titulo">
                                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                        {{ doc.modelo_documento.st_nome }}
                                                    </span>
                                                </a>
                                                <div v-if="doc.modelo_documento && doc.modelo_documento.js_classes && doc.modelo_documento.js_classes.length">
                                                    <span class="badge badge-success mr-1" v-for="(tag, itx) in doc.modelo_documento.js_classes" :key="itx">
                                                        {{ tag }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div>
                                                <span v-if="doc.created_at && doc.usuario" class="small text-muted ml-3">{{ $util.getFormatDate(doc.created_at) }}, por {{ doc.usuario.st_login }}</span>
                                                <span v-if="doc.model_id" class="small text-muted ml-3">#{{ doc.model_id }}</span>
                                                <az-audit-log-button model="documentoRecepcao" :id="doc.id_documento_recepcao" :link="true" sizing="sm" />
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <!-- Histórico -->
                                <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                    <ul class="list-group mt-3">
                                        <li class="list-group-item" v-for="(doc, idx) in lista_historico" :key="idx">
                                            <a href="#" @click.prevent="selecionarDocumento(doc, true)">
                                                {{ $util.getFormatDate(doc.dt_inclusao.substr(0, 10)) }}
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                {{ doc.st_titulo }}
                                                <span v-if="doc.modelo_documento && doc.modelo_documento.st_nome && doc.modelo_documento.st_nome != doc.st_titulo">
                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                    {{ doc.modelo_documento.st_nome }}
                                                </span>
                                            </a>
                                            <div class="small text-muted">
                                                <template v-if="$route.path.substr(0, 12) != '/assistencia'">
                                                    {{ doc.anamnese.atendimento_procedimento.procedimento.search }}
                                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                </template>
                                                {{ doc.anamnese.atendimento_procedimento.atendimento.medico.search }}
                                            </div>
                                            <div v-if="doc.modelo_documento && doc.modelo_documento.js_classes && doc.modelo_documento.js_classes.length">
                                                <span class="badge badge-success mr-1" v-for="(tag, itx) in doc.modelo_documento.js_classes" :key="itx">
                                                    {{ tag }}
                                                </span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <az-empty-state msg="Nenhum modelo identificado." />
                        </div>
                    </div>
                    <div
                        class="modal-footer d-flex justify-content-between flex-column flex-md-row"
                    >
                        <div class="form-group mb-0 mr-2" v-if="!videoaberto">
                            <select
                                class="form-control"
                                id="page-size"
                                type="select"
                                v-model="pageSize"
                            >
                                <option value="A4">A4</option>
                                <option value="A4-T">A4 (Timbrado)</option>
                                <option value="A4-NT">A4 (Não Timbrado)</option>
                                <option value="A5">A5</option>
                                <option value="A5-T">A5 (Timbrado)</option>
                                <option value="A5-NT">A5 (Não Timbrado)</option>
                            </select>
                        </div>
                        <div class="text-right">
                            <button
                                type="button"
                                class="btn btn-outline-secondary"
                                @click="voltar()"
                                v-if="
                                    documento &&
                                        !documento.id_documento_atendimento
                                "
                                key="voltar"
                            >
                                Voltar
                            </button>
                            <button
                                type="button"
                                class="btn btn-outline-danger"
                                v-if="
                                    documento &&
                                        documento.id_documento_atendimento
                                "
                                @click="removerDocumento()"
                            >
                                Remover
                            </button>
                            <button
                                type="button"
                                class="btn btn-secondary ml-2"
                                data-dismiss="modal"
                            >
                                Fechar
                            </button>

                            <az-submit
                                @click="atualizar(false)"
                                color="outline-success ml-2"
                                v-if="documento && ( !recepcao || documento.id_documento_recepcao || ( documento.modelo_documento && documento.modelo_documento.fl_salvar_recepcao ) ) && !pep_livre">
                                {{ ( documento.id_documento_atendimento || documento.id_documento_recepcao ) ? "Atualizar" : "Incluir" }}
                            </az-submit>

                            <az-submit
                                class="ml-2"
                                v-if="documento"
                                @click="atualizar()">
                                {{ ( ( recepcao && !documento.id_documento_recepcao && !( documento.modelo_documento && documento.modelo_documento.fl_salvar_recepcao ) ) || pep_livre )
                                        ? "Imprimir"
                                        : ( ( documento.id_documento_atendimento || documento.id_documento_recepcao )
                                            ? "Atualizar e Imprimir"
                                            : "Incluir e Imprimir"
                                        )
                                }}
                            </az-submit>

                            <az-submit
                                class="ml-2"
                                v-if="documento && documento.fl_ipsign && ( recepcao || podeassinar )"
                                @click="atualizar_assinar()"
                            >
                                {{
                                    recepcao
                                        ? "Assinar"
                                        : ( ( documento.id_documento_atendimento || documento.id_documento_recepcao )
                                            ? "Atualizar e assinar"
                                            : "Incluir e assinar"
                                        )
                                }}
                                <span v-if="documento.fl_ipsign"> IpSign</span>
                            </az-submit>

                            <az-submit
                                class="ml-2"
                                v-if="documento && documento.fl_zerodox && (recepcao || podeassinar )"
                                @click="atualizar_assinar(true)"
                            >
                                {{
                                    recepcao
                                        ? "Assinar"
                                        : ( ( documento.id_documento_atendimento || documento.id_documento_recepcao )
                                            ? "Atualizar e assinar"
                                            : "Incluir e assinar"
                                        )
                                }}
                                <span v-if="documento.fl_zerodox"> Zerodox</span>
                            </az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <DocumentoIPSign
            ref="documentoIPSignRef"
            :model_id="( marcacao && marcacao.id_marcacao ) ? marcacao.id_marcacao : model_id"
            :model_type="( marcacao && marcacao.id_marcacao ) ? 'marcacao' : model_type"
            :id_modelo_documento="documento ? documento.id_modelo_documento : null"
        />

        <DocumentoZerodox
            ref="documentoZerodoxRef"
            :model_id="marcacao ? marcacao.id_marcacao : null"
            model_type="marcacao"
            :id_modelo_documento="documento ? documento.id_modelo_documento : null"
        />
    </div>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import Formulario from "./Formulario.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzEditor from '../../shared/forms/AzEditor.vue';
import AzEmptyState from "../../util/AzEmptyState.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import DocumentoIPSign from "../../shared/DocumentoIPSign.vue";
import DocumentoZerodox from "../../shared/DocumentoZerodox.vue";
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzLoading from '../../util/AzLoading.vue';

export default {
    data() {
        return {
            formulario: null,
            documento: null,
            validate: false,
            modelos: null,
            pageSize: "A4",
            search: "",
            search_texto: "",
            marcacao: null,
            historico: null,
            nome_para: null, 
            lista_documento_recepcao: null, 
            model_type: null,
            model_id: null, 
            filtro_by_model_id: true, 
            apenas_favoritos: false, 
            outros_parms: {}, 
        };
    },

    props: [
        "anamnese",
        "videoaberto",
        "recepcao",
        "id_paciente",
        "infopaciente",
        "orcamento", 
        "podeassinar",
        "atendimento",
        "pep_livre", 
        "block_doc_titulo", 
        "id_procedimento"
    ],

    components: {
        Formulario,
        AzInput,
        AzEmptyState,
        AzSubmit,
        DocumentoIPSign,
        DocumentoZerodox,
        AzEditor, 
        AzAuditLogButton,
        AzLoading, 
    },

    computed: {
        modal_id: function() {
            return (
                "documentoModal" +
                (this.anamnese ? this.anamnese.id_anamnese : "")
            );
        },

        tags: function() {
            return !this.modelos
                ? []
                : _.uniq(
                      this.modelos
                          .filter(item => item.js_classes)
                          .flatMap(item => item.js_classes)
                          .sort()
                  );
        },

        lista_recepcao: function() { 
            if (!this.lista_documento_recepcao) 
                return [];

            return this.lista_documento_recepcao.filter(
                item =>
                    !this.search ||
                    (item.modelo_documento &&
                        item.modelo_documento.js_classes &&
                        item.modelo_documento.js_classes.find(
                            tag => tag == this.search
                        ))
            )
            .filter(item => !this.filtro_by_model_id || ( this.model_type && this.model_id && item.model_id == this.model_id ) );
        },


        lista_historico: function() {
            if (!this.historico) return [];

            return this.historico.filter(
                item =>
                    !this.search ||
                    (item.modelo_documento &&
                        item.modelo_documento.js_classes &&
                        item.modelo_documento.js_classes.find(
                            tag => tag == this.search
                        ))
            );
        },

        lista: function() {
            if (!this.modelos) return [];

            let reg = this.$util.getregex(this.search_texto);

            return this.modelos
                .filter(
                    item => ( 
                        !this.search ||
                        (item.js_classes &&
                            item.js_classes.find(tag => tag == this.search))
                    )
                    && ( !this.apenas_favoritos || item.favorito )      
                )
                .filter(
                    item => !this.search_texto || reg.test(JSON.stringify(item))
                );
        }
    },

    methods: {
        enviar_documento_por_email (doc) {
            
            if ( !this.marcacao ) {
                
                this.$toast.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Marcação não encontrada.',
                    life: 5000
                });

                return;

            }

            if ( !confirm("Confirma o envio do documento '" + doc.st_nome + "' por e-mail para o paciente?") )
                return; 

            this.axios.post('/imprimir/documento_recepcao', {
                ...doc,
                id_marcacao: this.marcacao.id_marcacao,
                fl_enviar_email: true,
                refresh: true, 
            }).then(response => {
                this.$toast.add({
                    severity: response.data.status_code == 200 ? 'success' : 'error',
                    summary: response.data.status_code == 200 ? 'Sucesso' : 'Erro',
                    detail: response.data.msg ? response.data.msg : 'Erro ao enviar e-mail.',
                    life: 5000
                });
            });

        },

        favoritar (item) {
            let model = {
                model_type: "modeloDocumento", 
                model_id: item.id_modelo_documento,
            };

            this.$util.loadItem(this, { 
                service: 'favoritos',
                func: 'favoritar',
                parms: model, 
            })
            .then(res => {
                if ( res ) { 
                    item.favorito = ( res && res.fl_ativo ) ? res : null;
                }
            });
        },

        imprimir_doc (modelo) { 
            this.$util.print_preview(
                'imprimir/documento_recepcao/', 
                false, 
                { 
                    ...modelo,
                    id_marcacao: this.marcacao.id_marcacao, 
                    id_orcamento: this.marcacao.id_marcacao ? null : this.marcacao.id_orcamento,
                    refresh: true, 
                    model_type: this.model_type,
                    model_id: this.marcacao.id_internacao
                }
            );
        },

        selecionar_tag(tag) {
            if (this.search == tag) {
                this.search = "";
            } else {
                this.search = tag;
            }

            this.$util.setCookie(
                "doc-tag-" + this.$store.state.user.id_usuario,
                this.search
            );
        },

        voltar() {
            this.$nextTick(() => {
                this.documento = null;
            });
        },

        removerDocumento() {
            if (!confirm("Confirma remover esse documento?")) return;

            this.$emit("remover", this.documento.id_documento_atendimento);

            this.$util.remover(this, {
                service: "documentos",
                dados: this.documento,
                modal: this.modal_id,
                callback: () => {
                    this.$emit("refresh");
                }
            });
        },

        selecionarDocumentoRecepcao(doc) { 
            this.validate = false;
            
            if ( !doc.modelo_documento ) { 
                return;
            }

            this.documento = {
                id_documento_recepcao: doc.id_documento_recepcao,
                st_titulo: doc.st_titulo,
                st_descricao: doc.st_texto,
                estrutura: null,
                fl_formulario: false,
                id_modelo_documento: doc.id_modelo_documento,
                salvar_modelo: false,
                arquivos: [],
                fl_html: doc.modelo_documento.fl_html,
                fl_compact: doc.modelo_documento.fl_compact,
                id_modelo_prontuario: null,
                fl_imprimir_sem_titulo: doc.modelo_documento.fl_imprimir_sem_titulo,
                fl_exibir_data: doc.fl_exibir_data,
                dt_referencia: doc.dt_referencia,
                fl_ipsign: doc.modelo_documento.fl_ipsign,
                fl_zerodox: doc.modelo_documento.fl_zerodox,
                fl_ipsign_laudo: doc.modelo_documento.fl_ipsign_laudo,
                st_chave_assinatura_ipsign: doc.modelo_documento.st_chave_assinatura_ipsign,
                modelo_documento: doc.modelo_documento,
            };
        },

        selecionarDocumento(modelo = null, historico = false) {
            if ( this.recepcao && this.lista_documento_recepcao && modelo.id_modelo_documento ) { 
                let doc = this.lista_documento_recepcao.find(d => d.id_modelo_documento == modelo.id_modelo_documento
                    && ( !this.model_type || d.model_type == this.model_type )
                    && ( !this.model_id || d.model_id == this.model_id )
                );

                if ( doc ) { 
                    if ( !confirm('Já existe um documento emitido para esse modelo. Confirma lançar um novo?') ) { 
                        return;
                    }
                }
            }

            this.validate = false;

            if (!modelo) {
                modelo = {
                    id_modelo_documento: null,
                    st_titulo: "Novo",
                    st_descricao: "",
                    fl_html: false, 
                    arquivos: []
                };
            }

            this.documento = {
                id_documento_atendimento: null,
                id_anamnese: this.anamnese ? this.anamnese.id_anamnese : null,
                st_titulo: modelo.st_titulo,
                st_descricao: modelo.st_descricao,
                estrutura: null,
                fl_formulario: false,
                id_modelo_documento: modelo.id_modelo_documento,
                modelo_documento: modelo, 
                salvar_modelo: false,
                arquivos: modelo.arquivos,
                fl_html: modelo.fl_html,
                fl_compact: modelo.fl_compact,
                id_modelo_prontuario: modelo.id_modelo_prontuario,
                fl_imprimir_sem_titulo: false,
                fl_exibir_data: true,
                dt_referencia: this.$util.hoje(),
                fl_ipsign: modelo.fl_ipsign,
                fl_zerodox: modelo.fl_zerodox,
                fl_ipsign_laudo: modelo.fl_ipsign_laudo,
                st_chave_assinatura_ipsign: modelo.st_chave_assinatura_ipsign,
                carregando: false, 
            };

            if ( this.nome_para ) { 
                this.documento.st_nome_para = this.nome_para;
            }

            if ( this.documento.st_descricao && this.anamnese && this.anamnese.dados ) { 
                this.documento.st_descricao = this.replace_hashtags(
                    this.documento.st_descricao,
                    this.obter_valroes(this.anamnese.dados)
                );
            }

            if ( modelo.id_modelo_documento && !historico ) { 
                this.carregar_modelos(modelo.id_modelo_documento);
            }
        },

        replace_hashtags(expression, valores) {
            // var regex = /(?:^|\s)(?:#)([a-zA-Z\d]+)/gm;
            var regex = /(?:#)([a-zA-Z_\-|\d]+)/gm;
            var matches = [];
            var match;

            while ((match = regex.exec(expression))) {
                matches.push(match[1]);
            }

            console.log('expression', expression);
            console.log('matches', matches);

            matches.forEach(hash => {
                let campo = valores.find(c => {
                    return c.id == hash;
                });

                if (campo) {
                    expression = expression.replace("#" + hash, campo.value);
                }
            });

            return expression;
        },

        carregar_modelos (id_modelo_documento = null) { 

            if ( id_modelo_documento && this.documento ) { 
                this.documento.carregando = true; 
            }

            this.$util.loadItem(this, {
                service: "modelo_documentos",
                func: "index",
                with: [
                    "arquivos.arquivo",
                    "favorito"
                ],
                parms: {
                    lista_geral: id_modelo_documento ? false : true, 
                    id_modelo_documento: id_modelo_documento,
                    pep: this.anamnese ? true : false,
                    pep_livre: this.pep_livre ? true : false, 
                    recepcao: this.recepcao ? true : false,
                    orcamento: this.orcamento ? true : false, 
                    id_anamnese: this.anamnese
                        ? this.anamnese.id_anamnese
                        : null,
                    id_medico: this.marcacao
                        ? this.marcacao.id_medico
                        : null,
                    id_procedimento: this.marcacao
                        ? this.marcacao.id_procedimento
                        : null,
                    id_marcacao: this.marcacao
                        ? this.marcacao.id_marcacao
                        : null,
                    id_orcamento: this.marcacao
                        ? this.marcacao.id_orcamento
                        : null,
                    id_atendimento: this.marcacao
                        ? this.marcacao.id_atendimento
                        : null,
                    id_internacao: this.marcacao
                        ? this.marcacao.id_internacao
                        : null,
                    ...this.outros_parms, 
                    model_type: this.model_type,
                    model_id: this.model_id,
                }
            })
            .then(res => {
                if ( id_modelo_documento ) { 
                    this.documento.st_descricao = res[0].st_descricao;
                    this.documento.modelo_documento = res[0]; 

                    if ( this.documento.st_descricao && this.anamnese && this.anamnese.dados ) { 
                        this.documento.st_descricao = this.replace_hashtags(
                            this.documento.st_descricao,
                            this.obter_valroes(this.anamnese.dados)
                        );
                    }

                    this.documento.carregando = false; 
                } else { 
                    this.modelos = res;
                }
            })
            .finally(() => {
                this.$store.commit("loading", false);
            });

        },

        novoDocumento(marcacao = null, outros_parms = {}, nome_para = null) {
            console.log('marcacao', marcacao);

            this.outros_parms = outros_parms;
            this.nome_para = nome_para; 
            this.formulario = null;
            this.validate = false;
            this.documento = null;
            this.marcacao = ( this.recepcao || this.pep_livre ) ? marcacao : null;

            this.model_type = null;
            this.model_id = null; 

            if (this.recepcao || this.pep_livre) this.modelos = null;

            if ( this.recepcao ) { 

                if ( outros_parms && outros_parms.id_solicitacao_autorizacao ) { 
                    this.marcacao.id_solicitacao_autorizacao = outros_parms.id_solicitacao_autorizacao;
                }

                if ( outros_parms && outros_parms.id_solicitacao_autorizacao ) { 
                    this.model_type = 'solicitacaoAutorizacao';
                    this.model_id = outros_parms.id_solicitacao_autorizacao;
                } else if ( this.marcacao && this.marcacao.id_marcacao ) { 
                    this.model_type = 'marcacao';
                    this.model_id = this.marcacao.id_marcacao;
                } else if ( this.marcacao && this.marcacao.id_orcamento ) { 
                    this.model_type = 'orcamento';
                    this.model_id = this.marcacao.id_orcamento;
                } else if ( this.marcacao && this.marcacao.id_internacao ) { 
                    this.model_type = 'internacao';
                    this.model_id = this.marcacao.id_internacao;
                }
                 
                if ( this.model_type && this.model_id ) { 

                    this.$util.loadItem(this, { 
                        service: 'documento_recepcaos',
                        func: 'index',
                        parms: { 
                            model_type: this.model_type,
                            model_id: this.model_id, 
                        },
                    })
                    .then(res => { 
                        this.lista_documento_recepcao = res;
                    });

                }

            }

            if (!this.modelos) {
                this.$store.commit("loading", true);
                $("#" + this.modal_id).modal("show");

                this.carregar_modelos(); 

                /*
                this.$util
                    .loadItem(this, {
                        service: "modelo_documentos",
                        func: "index",
                        with: [
                            "arquivos.arquivo",
                            "favorito"
                        ],
                        parms: {
                            lista_geral: true, 
                            pep: this.anamnese ? true : false,
                            pep_livre: this.pep_livre ? true : false, 
                            recepcao: this.recepcao ? true : false,
                            orcamento: this.orcamento ? true : false, 
                            id_anamnese: this.anamnese
                                ? this.anamnese.id_anamnese
                                : null,
                            id_medico: this.marcacao
                                ? this.marcacao.id_medico
                                : null,
                            id_procedimento: this.marcacao
                                ? this.marcacao.id_procedimento
                                : null,
                            id_marcacao: this.marcacao
                                ? this.marcacao.id_marcacao
                                : null,
                            id_orcamento: this.marcacao
                                ? this.marcacao.id_orcamento
                                : null,
                            id_atendimento: this.marcacao
                                ? this.marcacao.id_atendimento
                                : null,
                            id_internacao: this.marcacao
                                ? this.marcacao.id_internacao
                                : null,
                            ...outros_parms, 
                            model_type: this.model_type,
                            model_id: this.model_id,
                        }
                    })
                    .then(res => {
                        this.modelos = res;
                    })
                    .finally(() => {
                        this.$store.commit("loading", false);
                    });
                    */
            } else {
                $("#" + this.modal_id).modal("show");
            }

            if (!this.historico && this.anamnese && this.id_paciente) {
                this.$util
                    .loadItem(this, {
                        service: "pep",
                        func: "historico_documentos",
                        parms: {
                            id: this.id_paciente
                        }
                    })
                    .then(res => {
                        this.historico = res;
                    });
            }
        },

        definir_valor(estrutura, valores) {
            estrutura.forEach(campo => {
                if (campo.type == "group" || campo.type == "tabela") {
                    this.definir_valor(campo.campos, valores);
                } else {
                    if (campo.id) {
                        let item = valores.find(dadosCampo => {
                            return dadosCampo.id == campo.id;
                        });

                        if (item) {
                            campo.value = item.value;
                        }
                    }
                }
            });
        },

        obter_valroes(estrutura) {
            let base = [];

            if (estrutura) {
                estrutura.forEach(campo => {

                    let campo_c = _.cloneDeep(campo);

                    if (campo_c.type == "group" || campo_c.type == "tabela") {
                        base = base.concat(this.obter_valroes(campo_c.campos));
                    } else if (campo_c.type == "label" ) {
                        //
                    } else {
                        if (campo_c.id && campo_c.value && campo_c.id.slice(-2) == '-o' ) {

                            if ( ( campo_c.value && typeof campo_c.value == 'string' ) ) { 
                                campo_c.value = campo_c.value.replace(',', '.');
                            }

                            campo_c.value = ( campo_c.value > 0 ? '+' : '' ) + this.$util.formatNumber(campo_c.value, 2); 

                        }

                        if (campo_c.id && campo_c.value) {
                            base.push(campo_c);
                        }
                    }
                });
            }

            return base;
        },

        novoFormulario(id_modelo) {
            if (!this.anamnese) {
                alert("Atendimento não identificado.");
                return;
            }

            this.validate = false;

            this.$util
                .loadItem(this, {
                    service: "modelos",
                    id: id_modelo,
                    parms: { 
                        id_atendimento_procedimento: this.anamnese ? this.anamnese.id_atendimento_procedimento : null,
                        model: 'documentoAtendimento', 
                    }
                })
                .then(res => {
                    this.formulario = res;

                    console.log("AN", this.anamnese);
                    console.log("FN", this.formulario);

                    this.definir_valor(
                        this.formulario.estrutura,
                        this.obter_valroes(this.anamnese.dados)
                    );

                    if ( res.heranca_campos ) { 
                        this.definir_valor(
                            this.formulario.estrutura,
                            this.obter_valroes(res.heranca_campos)
                        );  
                    }

                    this.documento = {
                        id_documento_atendimento: null,
                        id_anamnese: this.anamnese.id_anamnese,
                        st_titulo: res.st_titulo_impressao
                            ? res.st_titulo_impressao
                            : res.st_modelo_prontuario,
                        st_descricao: this.formulario.estrutura,
                        estrutura: this.formulario.estrutura,
                        fl_formulario: true,
                        st_layout_impressao: this.formulario
                            .st_layout_impressao,
                        layout_impressao: this.formulario.st_layout_impressao,
                        fl_compact: this.formulario.fl_compact,
                        id_modelo_documento: this.formulario
                            .id_modelo_documento,
                        id_modelo_prontuario: this.formulario
                            .id_modelo_prontuario
                    };
                    $("#" + this.modal_id).modal("show");
                });
        },

        editar(doc) {
            if (doc.doc_certificado) {
                this.$toast.add({
                    severity: "warn",
                    summary: "Editar",
                    detail: "Documento já assinado. Edição não disponível.",
                    life: 3000
                });
                return;
            }

            this.formulario = null;
            this.documento = null;
            this.validate = false;

            this.$nextTick(() => {
                if (doc && doc.fl_html_modelo) {
                    doc.fl_html = doc.fl_html_modelo;
                }

                this.documento = _.cloneDeep(doc);
                $("#" + this.modal_id).modal("show");
            });
        },

        atualizar(imprimir = true) {
            if (this.recepcao || this.pep_livre) {
                $("#" + this.modal_id).modal("hide");

                this.$util.print_preview(
                    "imprimir/documento_recepcao/",
                    false,
                    {
                        ...this.documento,
                        id_marcacao: this.marcacao
                            ? this.marcacao.id_marcacao
                            : null,
                        id_orcamento: this.marcacao
                            ? this.marcacao.id_orcamento
                            : null,
                        id_solicitacao_autorizacao: this.marcacao
                            ? this.marcacao.id_solicitacao_autorizacao
                            : null,
                        st_papel: this.pageSize,
                        model_type: this.model_type, 
                        model_id: this.model_id, 
                    }
                );

                return;
            }

            this.$util.atualizar(this, {
                service: "documentos",
                dados: this.documento,
                modal: this.modal_id,
                callback: doc => {
                    this.documento = doc;
                    this.$util.setCookie("page-size", this.pageSize, 365);
                    this.$emit("refresh", imprimir ? this.documento : null);

                    this.$emit("solicitar", this.documento); 
                }
            });
        },

        atualizar_assinar(zerodox = false) {
            this.$store.commit("loading", true);

            const isWord = _.get(this.documento, "modelo_documento.fl_layout_word", false);

            this.axios
                .post(
                    "imprimir/documento_recepcao/",
                    {
                        ...this.documento,
                        id_marcacao: this.marcacao
                            ? this.marcacao.id_marcacao
                            : null,
                        st_papel: this.pageSize,
                        assinar_word: isWord,
                    },
                    {
                        data: {},
                        responseType: "arraybuffer"
                    }
                )
                .then(response => {
                    let blob = new Blob([response.data], {
                        type: "application/pdf"
                    });

                    let id_atendimento = this.marcacao && this.marcacao.atendimento ? this.marcacao.atendimento.id_atendimento : null;
                    if (!id_atendimento && this.atendimento) {
                        id_atendimento = this.atendimento.id_atendimento;
                    }

                    this.$util.atualizar(this, {
                        service: "ipsign",
                        func: "dados_envio",
                        dados: {
                            id_atendimento: id_atendimento,
                            id_marcacao:
                                this.marcacao
                                    ? this.marcacao.id_marcacao
                                    : null,
                            id_orcamento: this.model_type == 'orcamento' ? this.model_id : null,
                            model_type: this.model_type,
                            model_id: this.model_id, 
                        },
                        callback: res => {
                            if (res.status_code && res.status_code == 403) {
                                this.$toast.add({
                                    severity: "warn",
                                    summary: "Ipsign",
                                    detail: res.msg
                                        ? res.msg
                                        : "Erro ao consultar dados do paciente",
                                    life: 3000
                                });
                                return;
                            }

                            const nome = res.nome;
                            const cpf = res.cpf;
                            const email = res.email;
                            const dt_nascimento = res.dt_nascimento;

                            let unidade = _.get(
                                this.marcacao,
                                "unidade_operacao.st_nome"
                            );
                            let operadora = _.get(
                                this.marcacao,
                                "plano.search"
                            );

                            if (this.atendimento) {
                                unidade = res.unidade;
                                operadora = res.plano;
                            }

                            // quantidade de ocorrencias da tag de assinatura
                            var qtdOcorrenciasAss = 0;
                            if (this.documento && this.documento.st_chave_assinatura_ipsign) {
                                var substrings = this.documento.st_descricao.split(this.documento.st_chave_assinatura_ipsign);
                                if (substrings && substrings.length > 0) {
                                    qtdOcorrenciasAss = substrings.length - 1;
                                }
                            }

                            var reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onloadend = () => {
                                var base64data = reader.result.replace(
                                    "data:application/pdf;base64,",
                                    ""
                                );

                                // model_type
                                var m_type = this.atendimento ? 'anamnese' : null;
                                var m_id = this.atendimento ? this.anamnese.id_anamnese : null;
                                // anexar documento como laudo externo
                                if (this.documento.fl_ipsign_laudo && this.anamnese && this.anamnese.id_laudo) {
                                    m_type = 'laudo';
                                    m_id = this.anamnese.id_laudo;
                                }

                                $("#" + this.modal_id).modal("hide");

                                if (zerodox) {
                                    this.$refs.documentoZerodoxRef.show(
                                        base64data,
                                        this.documento.st_titulo,
                                        email,
                                        cpf,
                                        nome,
                                        unidade,
                                        operadora,
                                        dt_nascimento,
                                        m_id,
                                        m_type,
                                        this.atendimento ? this.atendimento.id_atendimento : null
                                    );
                                } else {
                                    // IPSIGN
                                    this.$refs.documentoIPSignRef.show(
                                        base64data,
                                        this.documento.st_titulo,
                                        email,
                                        cpf,
                                        nome,
                                        unidade,
                                        operadora,
                                        this.documento.st_chave_assinatura_ipsign,
                                        qtdOcorrenciasAss,
                                        dt_nascimento,
                                        m_id,
                                        m_type,
                                        this.atendimento ? this.atendimento.id_atendimento : null
                                    );
                                }
                            };
                        }
                    });
            })
            .finally(() => {
                this.$store.commit("loading", false);
            });

        },

    },

    mounted() {
        this.pageSize = this.$util.getCookie("page-size");
        this.search = this.$util.getCookie(
            "doc-tag-" + this.$store.state.user.id_usuario
        );
    }
};
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>
